export function createPropsGetter(defaultProps) {
  return function () {
    return this.props;
  };
}